// extracted by mini-css-extract-plugin
module.exports = {"poweredBy":"styles_poweredBy__yOT7M","orange":"styles_orange__yN-1V","logo":"styles_logo__2sD3v"};